import { fetchWithAuth } from './utils';

export const fetchLogsSettingsList = async () => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/logs/settings`);

    try {
        const response = await fetchWithAuth(url, {
            method: 'POST',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        
        return data; 
    } catch (error) {
        console.error('Failed to fetch device list:', error);
        throw error; 
    }
};

export const fetchLogsDetailList = async (deviceId) => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/logs/device-detail`);
    url.searchParams.append('device_id', deviceId);
    try {
        const response = await fetchWithAuth(url, {
            method: 'POST',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch device list:', error);
        throw error;
    }
};


export async function fetchLogsReportsList() {
    const url = new URL(`${process.env.REACT_APP_API_URL}/logs/reports`);

    try {
        const response = await fetchWithAuth(url, {
            method: 'POST',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Failed to fetch device list:', error);
        throw error;
    }
};